import './cart.css';

export default () => {
  const init = () => {
    class Cart extends HTMLElement {
      constructor() {
        super();
        this.cart = {
          mode: 'storefront',
          state: {
            lines: [],
            subtotal: {amount: 0},
            totalPrice: 0,
            checkoutUrl: '/checkout',
          },
        };
        document.addEventListener('cart-update', this.updateCart.bind(this));
      }

      connectedCallback() {
        this.addCartToggleListener();
        this.addClickOutsideListener();
      }

      addCartToggleListener() {
        const cartTrigger = document.querySelector('[data-header-cart-trigger]');
        if (cartTrigger) {
          cartTrigger.addEventListener('click', () => {
            // Save the last focused element (the button)
            this.lastFocusedElement = document.activeElement;

            const cartPanel = this.querySelector('#cart-panel');
            if (cartPanel.getAttribute('default-open') !== 'true') {
              cartPanel.setAttribute('default-open', 'true');
              this.renderCart(); // Render cart content when the drawer is opened
              this.trapFocus(cartPanel)
              // Move focus to the first focusable element in the mobile menu
              const firstFocusableElement = cartPanel.querySelector('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
              if (firstFocusableElement) {
                firstFocusableElement.focus()
              }
            }
            this.querySelector('.drawer-popup').classList.remove('empty-cart-drawer')
            document.body.classList.add('overflow-hidden');
            document.querySelector('body').classList.add('no-scroll');

          });
        }
        const closeButton = this.querySelector('[data-cart-close-trigger]');
        if (closeButton) {
          closeButton.addEventListener('click', () => {
            this.closeCartPanel();
          });
        }
      }

      // Function to trap focus inside the mobile menu
      trapFocus(dialog) {
        const focusableElements = dialog.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');

        const removeHiddenButtons = [...focusableElements].filter((el) => {
          const parent = el.parentElement;
          return !parent.classList.contains('hidden');
        });

        const firstFocusableElement = removeHiddenButtons[0];
        const lastFocusableElement = removeHiddenButtons[removeHiddenButtons.length - 1];

        dialog.addEventListener('keydown', (e) => {

          if (e.key === 'Tab') {
            if (e.shiftKey) { // Shift + Tab
              if (document.activeElement === firstFocusableElement) {
                e.preventDefault();
                lastFocusableElement.focus(); // Move focus to last element if Shift + Tab on first element
              }
            } else {
              // eslint-disable-next-line
              if (document.activeElement === lastFocusableElement) {
                e.preventDefault();
                firstFocusableElement.focus(); // Move focus to first element if Tab on last element
              }
            }

            if (document.activeElement === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus(); // Move focus to first element if Tab on last element
            }
          }
        });

        this.firstFocusableElement = firstFocusableElement
        this.lastFocusableElement = lastFocusableElement
      }

      // Function to release the focus trap
      releaseFocusTrap() {
        const dialog = this.querySelector('.search-bar');
        if (dialog) {
          dialog.removeEventListener('keydown', this.trapFocus);
        }
      }

      addClickOutsideListener() {
        this.querySelector('.slide-panel__bg').addEventListener('click', () => {
          const cartPanel = this.querySelector('#cart-panel');
          if (cartPanel && cartPanel.getAttribute('default-open') === 'true') {
            this.closeCartPanel();
          }
        });
      }

      closeCartPanel() {
        const cartPanel = this.querySelector('#cart-panel');

        cartPanel.setAttribute('default-open', 'false');
        document.body.classList.remove('overflow-hidden');
        document.querySelector('body').classList.remove('no-scroll');


        // Return focus to the last focused element or to the body
        if (this.lastFocusedElement && document.contains(this.lastFocusedElement)) {
          this.lastFocusedElement.focus()
        } else {
          document.body.focus()
        }

        this.releaseFocusTrap();
      }

      updateCart(event) {
        const cartData = event.detail;

        fetch('/cart.js')
          .then((res) => res.json())
          .then((data) => {
            // Update the cart drawer content with new cartData
            this.cart.state.lines = cartData.items || data.items; // Fallback to existing lines if items are not present
            this.cart.state.subtotal.amount = cartData.total_price || data.total_price; // Fallback to existing subtotal if not present
            this.cart.state.totalPrice = cartData.total_price || data.total_price; // Fallback to existing total price if not present

            // Update the cart count in the header
            const cartCountElement = document.querySelector('[data-cart-count]');
            if (cartCountElement) {
              cartCountElement.textContent = data.item_count
            }
          });
      }

      updateQuantity(event) {
        const button = event.currentTarget;
        const action = button.getAttribute('name');
        const quantityElement = button.closest('.cart-quantity').querySelector('.quantity__input');
        const variantId = quantityElement.getAttribute('data-quantity-variant-id');
        const headerCartCount = document.querySelector('.header-cart-products-qty');
        let quantity = parseInt(quantityElement.textContent, 10);
        let currentQty = 0

        if (action === 'plus') {
          quantity += 1;
          this.querySelectorAll('.cart-products-qty').forEach(qty => {
            currentQty = Number(qty.innerHTML) + 1
            // eslint-disable-next-line
            qty.innerHTML = currentQty
            headerCartCount.innerHTML = currentQty
          })
        } else if (action === 'minus' && quantity > 1) {
          quantity -= 1;
          this.querySelectorAll('.cart-products-qty').forEach(qty => {
            currentQty = Number(qty.innerHTML) - 1
            // eslint-disable-next-line
            qty.innerHTML = currentQty
            headerCartCount.innerHTML = currentQty
            if (currentQty < 0) {
              headerCartCount.innerHTML = 0
            } else {
              headerCartCount.innerHTML = currentQty
            }
          })
        }

        this.updateCartItem(variantId, quantity);
      }

      removeItem(event) {
        const button = event.currentTarget;
        const variantId = button.getAttribute('data-variant-id');
        const headerCartCount = document.querySelector('.header-cart-products-qty');
        const currentMainCount = Number(headerCartCount.innerHTML)
        const removedQty = document.querySelector(`.quantity__input[data-quantity-variant-id="${variantId}"]`).innerHTML
        headerCartCount.innerHTML = currentMainCount - Number(removedQty)
        this.updateCartItem(variantId, 0);
      }

      updateCartItem(variantId, quantity) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            this.updateCartDisplay(data);
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Error updating cart:', error);
          });
      }

      updateCartDisplay(cart) {
        cart.items.forEach((item) => {
          const quantityElement = this.querySelector(`.quantity__input[data-quantity-variant-id="${item.variant_id}"]`);
          if (quantityElement) {
            quantityElement.textContent = item.quantity;
          }
        });

        // Remove items with zero quantity
        this.querySelectorAll('.cart-remove-button').forEach((button) => {
          const variantId = button.getAttribute('data-variant-id');
          const item = cart.items.find((elem) => elem.variant_id === parseInt(variantId, 10));
          if (!item) {
            const cartItem = button.closest('[data-section="cart-item"]');
            if (cartItem) {
              cartItem.remove();
            }
          }
        });

        document.querySelectorAll('.cart-total-price').forEach((item) => {
          // eslint-disable-next-line
          item.textContent = this.formatMoney(
            {
              amount: cart.total_price,
              currencyCode: Shopify.currency.active,
            },
            true
          );
        });

        // Re-attach event listeners for the new elements
        this.attachEventListeners();
        this.renderCart();
      }

      formatMoney({amount, currencyCode = 'USD'}, cents = false) {
        let amt = amount;
        if (Number.isNaN(amt))
          // eslint-disable-next-line no-console
          return console.error('utils/format-money.js: No amount value passed.');

        if (cents) amt /= 100;

        const isWholeNumber = amt % 1 === 0;

        const formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: isWholeNumber ? 0 : 2,
          maximumFractionDigits: 2,
        });

        return formatter.format(amt);
      };

      attachEventListeners() {
        // Event listeners for quantity buttons
        this.quantityBtns = this.querySelectorAll('.quantity__button');
        this.quantityBtns.forEach((button) => {
          button.addEventListener('click', this.updateQuantity.bind(this));
        });

        // Event listeners for remove buttons
        this.removeBtns = this.querySelectorAll('.cart-remove-button');
        this.removeBtns.forEach((button) => {
          button.addEventListener('click', this.removeItem.bind(this));
        });
      }

      renderCart() {
        fetch('/cart.js')
          .then((res) => res.json())
          .then((data) => {

            // Update the cart drawer content with new cartData
            this.cart.state.lines = data.items;
            this.cart.state.subtotal.amount = data.total_price;
            this.cart.state.totalPrice = data.total_price;

            const cartItemsContainer = this.querySelector('.cart-drawer-body');
            if (cartItemsContainer) {
              cartItemsContainer.innerHTML = ''; // Clear existing items
              if (this.cart.state.lines.length > 0) {
                if (document.querySelector('.empty-cart-text')) {
                  document.querySelector('.empty-cart-text').classList.add('hidden')
                }


                this.querySelectorAll('.cart-products-qty').forEach(qty => {
                  // eslint-disable-next-line
                  qty.innerHTML = data.item_count
                })

                this.cart.state.lines.forEach((product, index) => {
                  const itemElement = document.createElement('cart-items');
                  itemElement.classList.add('block');


                  const formattedPrice = this.formatMoney(
                    {
                      amount: product.price,
                      currencyCode: Shopify.currency.active,
                    },
                    true
                  );
                  let optionsList = '';
                  let wishlistBtn = ''
                  if (product.handle === 'standard-packaging' || product.handle === 'luxury-packaging' || product.handle.includes('scarf') || product.handle.includes('chocolate-truffle-set')) {
                    wishlistBtn = ''
                  } else {
                    wishlistBtn = `<button data-with-epi="true" tabindex="0"
                       class="swym-button swym-add-to-wishlist-view-product cart-wishlist product_${product.product_id}
                         !whitespace-nowrap !static"
                            data-swaction="addToWishlist"
                            data-product-id="${product.product_id}"
                            data-variant-id="${product.variant_id}"
                            data-product-url="https://foundrae.com${product.url}">
                    </button>`
                  }

                  product.options_with_values.forEach(option => {
                    if(String(option).charAt(0)!== '_'){
                      optionsList += `
                <div class="product-option body-4 flex mb-[11px] !text-10 ${option.name.toLowerCase() === "quantity of letters" ? 'flex-col items-start' : ' items-center'}">
                   <dt class="uppercase">${option.name}:</dt>
                   <dd class="uppercase ml-1 shrink-0">${option.value}</dd>
                </div>`
                    }
                  })

                  let propertiesList = '';

                  if (product.properties) {
                    const propObj = product.properties;
                    if (Object.keys(propObj).length > 0) {
                      Object.entries(propObj).forEach(([key, value]) => {
                        const cleanValue = value.startsWith('-') ? value.replace('-', '') : value;
                        const cleanedKey = key.replace(/letters for/i, '').trim();
                        if(String(key).charAt(0) !== '_') {
                          propertiesList += `
                        <div class="product-option body-4 !text-10 flex mb-[11px] ${cleanedKey.toLowerCase() === "quantity of letters" ? 'flex-col items-start' : ' items-center'}">
                           <dt class="uppercase">${cleanedKey}:</dt>
                           <dd class="uppercase ml-1 shrink-0">${cleanValue}</dd>
                         </div>`;
                        }
                      });
                    }
                  }


                  const [titlePart1, titlePart2] = product.product_title.split(':');
                  // eslint-disable-next-line
                  const secondTitle = titlePart2 ? titlePart2 : ''
                  itemElement.innerHTML = `
                 <div class="flex border-b border-light_gray w-full px-4 gap-3 productData" role="group"
                  data-section="cart-item"
                  aria-label="product">
          <div class="shrink-0">
            <a href="${product.url}">
              <picture class="w-[100px] inline-block">
                <source srcset="${product.image}?v=1672868156&amp;width=1536 1536w" media="(min-width: 640px)">
                <img class="w-full image " src="${product.image}"
                alt="${product.product_title}" loading="lazy" width="" height="">
              </picture>
            </a>
          </div>
          <div class="grow cart-product-card cart-product-card${index}">
    <h3 class="pdp__title font-regular text-16 leading-21px mb-8 flex justify-between items-start gap-2 !ledaing-cart">
              <a href="${product.url}">
                <em>${titlePart1}</em><br>
               <span>${secondTitle}</span>
              </a>
              <span class="body-4 shrink-0 mt-[3px] !text-12">${formattedPrice}</span>
            </h3>
            <dl role="presentation">
                ${optionsList}
                ${propertiesList}
            </dl>


            <div class="cart-item__quantity-wrapper quantity-popover-wrapper flex justify-between items-center gap-2">
                <div class="quantity-popover-container flex gap-3">
                  <div class="body-4 uppercase !text-10">Quantity</div>
                  <div class="quantity cart-quantity flex gap-2.5">
                   <button
                   class="quantity__button border rounded-full h-4 w-4 flex justify-center items-center cursor-pointer"
                   name="minus" type="button" aria-label="Decrease quantity">

                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" role="img"
                        stroke="currentColor" aria-label="Minus"
                        class="h-3 w-3" aria-labelledby="minus-button">
                        <title id="minus-button"></title>
                          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15"></path>
                        </svg>

                   </button>
                        <p class="quantity__input border-0 body-4"
                        data-quantity-variant-id="${product.variant_id}"
                        data-cart-quantity="${product.quantity}"
                        aria-label="quantity"
                        id="item-quantity-${index + 1}" data-index="${index + 1}">${product.quantity}</p>
                   <button
                   class="quantity__button border rounded-full h-4 w-4 flex justify-center items-center cursor-pointer"
                   name="plus" type="button" aria-label="Increase quantity">

                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" role="img"
                          viewBox="0 0 24 24" stroke-width="1.5"
                          aria-labelledby="plus-button"
                          stroke="currentColor" aria-label="Plus" class="h-3 w-3">
                          <title id="plus-button"></title>
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"></path>
                          </svg>
                   </button>
                  </div>
                </div>
                <div id="cart-remove-${index + 1}" data-index="${index + 1}"
                class="text-right flex flex-col items-end gap-1  mt-2">
                    ${wishlistBtn}
              
                    <button type="button"
                    class="button--tertiary cart-remove-button body-4 text-text_gray underline uppercase !text-[9px]"
                    data-variant-id="${product.variant_id}"
                     data-title="${product.product_title}"
                                data-price="${formattedPrice}"
                                data-vendor="${product.vendor}"
                                data-variant-title="${product.title}">
                        Delete
                    </button>
                </div>
            </div>
          </div>
        </div>
                `;
                  cartItemsContainer.appendChild(itemElement);
                });
                document.dispatchEvent(new CustomEvent('swym:collections-loaded'))
                document.querySelectorAll('.empty-cart-footer').forEach(item => {
                  item.classList.add('hidden')
                })
                document.querySelectorAll('.not-empty-cart-footer').forEach(item => {
                  item.classList.remove('hidden')
                })
              } else {
                this.querySelector('.cart-products-qty').textContent = 0

                document.querySelectorAll('.empty-cart-footer').forEach(item => {
                  item.classList.remove('hidden')
                })
                document.querySelectorAll('.empty-cart-text').forEach(item => {
                  item.classList.remove('hidden')
                })

                document.querySelectorAll('.not-empty-cart-footer').forEach(item => {
                  item.classList.add('hidden')
                })
              }
            }

            const cartSubtotalElement = this.querySelector('.cart-total-price');

            if (cartSubtotalElement) {
              cartSubtotalElement.textContent = this.formatMoney({
                amount: this.cart.state.subtotal.amount,
                currencyCode: Shopify.currency.active
              }, true);
            }

            // Attach event listeners for new elements
            this.attachEventListeners();
          });
      }
    }

    if (!customElements.get('drawer-cart')) {
      customElements.define('drawer-cart', Cart);
    }
  };

  init();
};
